<template>
  <div class="login w-100 h-100 d-flex">
    <section class="bg-blur login auth col-12 mx-auto align-self-md-center col-md-7 col-xl-4 col-xxl-4">
      <div class="half-design row">
        <div class="col-12 form-block">
          <div class="logo col-auto p-0">
            <img src="@/assets/logo_full.svg" alt="logo" height="70px" class="mx-auto" />
          </div>

          <div class="col-12 col-md-10 mx-auto mt-3">
            <b-form @submit.prevent="onSubmit">
              <div class="mb-3 text-left">
                <label class="mb-1" for="email" :class="emailState">{{ $t('title.email') }}</label>
                <b-form-input id="email" type="email" v-model="formFields.email" @input="validateEmail"
                  :class="emailState"></b-form-input>

                <b-form-invalid-feedback :state="!formErrors.has('email')">
                  {{ formErrors.first('email') }}
                </b-form-invalid-feedback>

              </div>
              <div class="mb-3 text-left">
                <label class="mb-1" for="email" :class="emailState">{{ $t('title.password') }}</label>

                <b-form-input id="password" type="password" v-model="formFields.password" @input="validatePassword"
                  :class="passwordState"></b-form-input>


                <b-form-invalid-feedback :state="!formErrors.has('password')">
                  {{ formErrors.first('password') }}
                </b-form-invalid-feedback>
              </div>
                <div class="mb-3 form-check">
                    <b-form-checkbox v-model="keepLoggedIn">
                        {{ $t('title.keep_me_logged_in') }}
                    </b-form-checkbox>
                </div>
                <div id="recaptcha-container">
                    <div
                        class="g-recaptcha"
                        :data-sitekey="recaptchaSiteKey"
                        data-callback="onRecaptchaSuccess"
                        data-error-callback="onRecaptchaError"
                        data-expired-callback="onRecaptchaExpired"
                    ></div>
                </div>
                <b-form-invalid-feedback v-if="captchaError" style="display: block;">
                    {{ captchaError }}
                </b-form-invalid-feedback>

              <b-button type="submit" variant="primary" class="mb-3 w-100 mt-3">
                {{ $t('title.submit') }}
              </b-button>
              <b-form-invalid-feedback v-if="formErrors.general">{{
                formErrors.general
                }}</b-form-invalid-feedback>
              <p>
                {{ $t('title.Forgot_password') }}
                <router-link :to="{ name: 'ForgotPassword' }"> {{ $t('title.Click_here') }}</router-link>
              </p>
            </b-form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import commonMixin from "@/Util/commonMixin";
import Error from "@/Util/Error";

export default {
  mixins: [commonMixin],
  data() {
    return {
      defaultCredentials: {
        email: 'test@example.com',
        password: 'password123',
      },
      formFields: reactive({
        email: '',
        password: '',
      }),
        keepLoggedIn: false,  // new field
        recaptchaToken: '',
        captchaError: null,
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      //   formErrors: reactive({
      //     email: '',
      //     password: ''
      //     }),
      formErrors: new Error({}),
    };
  },
    mounted() {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/enterprise.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
        window.onRecaptchaSuccess = this.onVerify;
        window.onRecaptchaError = this.onError;
        window.onRecaptchaExpired = this.onExpired;
    },
  computed: {
    // ...mapGetters(['loader']),
    emailState() {
      return this.formFields.email === undefined || this.formFields.email === ''
        ? ''
        : this.formErrors.$errors.email
          ? 'is-invalid'
          : 'is-valid';
    },
    passwordState() {
      return this.formFields.password === undefined || this.formFields.password === ''
        ? ''
        : this.formErrors.$errors.password
          ? 'is-invalid'
          : 'is-valid';
    },
  },
  methods: {
      onVerify(token) {
          this.recaptchaToken = token;
          this.formFields['g-recaptcha-response'] = token;
          this.captchaError = "";
      },
      onError() {
          this.recaptchaToken = '';
          this.captchaError = "reCAPTCHA error occurred. Please try again";
          this.resetCaptcha();
      },
      onExpired() {
          this.recaptchaToken = '';
          this.captchaError = "CAPTCHA expired. Please verify again.";
          this.resetCaptcha();
      },
      waitForRecaptchaReady(callback) {
          const interval = setInterval(() => {
              if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {
                  clearInterval(interval);
                  callback();
              }
          }, 100);
      },
      resetCaptcha(){
          this.$nextTick(() => {
              const container = document.getElementById("recaptcha-container");
              if (container) {
                  container.innerHTML = ''; // remove old captcha
                  const newDiv = document.createElement('div');
                  newDiv.className = 'g-recaptcha';
                  newDiv.setAttribute('data-sitekey', this.recaptchaSiteKey);
                  newDiv.setAttribute('data-callback', 'onRecaptchaSuccess');
                  newDiv.setAttribute('data-error-callback', 'onRecaptchaError');
                  newDiv.setAttribute('data-expired-callback', 'onRecaptchaExpired');
                  container.appendChild(newDiv);

                  this.waitForRecaptchaReady(() => {
                      window.grecaptcha.enterprise.render(newDiv);
                  });

              }
          });
      },
      validateEmail() {
      if (!this.formFields.email || !/.+@.+\..+/.test(this.formFields.email)) {
        this.formErrors = new Error({
          email: ['Enter a valid email']
        });
      } else {
        this.formErrors = new Error({});
      }
    },
    validatePassword() {
      if (!this.formFields.password || this.formFields.password.length < 6) {
        this.formErrors = new Error({
          password: ['Password must be at least 6 characters']
        });
      } else {
        this.formErrors = new Error({});
      }
    },
    async onSubmit() {
      try {
        if (!this.recaptchaToken) {
          this.captchaError = 'Please complete the captcha.';
          return;
        }
        const response = await request({
          method: 'post',
          url: `auth/login`,
          data: {
            email: this.formFields.email,
            password: this.formFields.password,
            captcha: this.recaptchaToken,
              keep_logged_in: this.keepLoggedIn,  // send this info
          }
        });

        this.showToast();

        // Redirect to OTP verification page with email
        this.$router.push({
          name: 'VerifyOtp',
          query: { email: this.formFields.email }
        }, 5000);

      } catch (error) {
        if (error.request && error.request.status === 422) {
          this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
          return false;
        } else {
          this.notifyError();
        }
          this.resetCaptcha();

      }
    },


    showToast() {
      const h = this.$createElement;
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
        `Otp Send SucessFully Please Varify`,
      ]);
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [h('strong', { class: 'mr-2' }, 'Otp Send SucessFully')]
      );
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: 'success',
      });
    },

  },
};
</script>
